export const TRACKER_TYPES = Object.freeze({
  GOAL: 'goal',
  BEHAVIOR: 'behavior',
  MEDICATION_EFFECT: 'medication_effect',
  HEALTH_SYMPTOM: 'health_symptom',
  SUPPORT_STRATEGY: 'support_strategy',
  ROUTINE_HABIT: 'routine_habit',
});

export const TRACKER_TYPE_LABELS = Object.freeze({
  [TRACKER_TYPES.GOAL]: 'Goal',
  [TRACKER_TYPES.BEHAVIOR]: 'Behavior',
  [TRACKER_TYPES.MEDICATION_EFFECT]: 'Medication Effect',
  [TRACKER_TYPES.HEALTH_SYMPTOM]: 'Health / Symptom',
  [TRACKER_TYPES.SUPPORT_STRATEGY]: 'Support Strategy',
  [TRACKER_TYPES.ROUTINE_HABIT]: 'Routine / Habit',
});

const TRACKER_TYPE_ALIASES = Object.freeze({
  goal: TRACKER_TYPES.GOAL,
  goals: TRACKER_TYPES.GOAL,
  behavior: TRACKER_TYPES.BEHAVIOR,
  behaviour: TRACKER_TYPES.BEHAVIOR,
  incident: TRACKER_TYPES.BEHAVIOR,
  medication: TRACKER_TYPES.MEDICATION_EFFECT,
  medication_effect: TRACKER_TYPES.MEDICATION_EFFECT,
  medicationeffect: TRACKER_TYPES.MEDICATION_EFFECT,
  med_effect: TRACKER_TYPES.MEDICATION_EFFECT,
  treatment_effect: TRACKER_TYPES.MEDICATION_EFFECT,
  health: TRACKER_TYPES.HEALTH_SYMPTOM,
  symptom: TRACKER_TYPES.HEALTH_SYMPTOM,
  symptoms: TRACKER_TYPES.HEALTH_SYMPTOM,
  health_symptom: TRACKER_TYPES.HEALTH_SYMPTOM,
  support: TRACKER_TYPES.SUPPORT_STRATEGY,
  strategy: TRACKER_TYPES.SUPPORT_STRATEGY,
  support_strategy: TRACKER_TYPES.SUPPORT_STRATEGY,
  routine: TRACKER_TYPES.ROUTINE_HABIT,
  habit: TRACKER_TYPES.ROUTINE_HABIT,
  routine_habit: TRACKER_TYPES.ROUTINE_HABIT,
});

const normalizeKey = (value = '') => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_+|_+$/g, '');

export const normalizeTrackerType = (value = '') => (
  TRACKER_TYPE_ALIASES[normalizeKey(value)] || ''
);

export const getTrackerTypeLabel = (type = '') => (
  TRACKER_TYPE_LABELS[normalizeTrackerType(type) || type] || ''
);

export const TRACKER_TYPE_OPTIONS = Object.freeze(
  Object.values(TRACKER_TYPES).map((type) => Object.freeze({
    type,
    label: TRACKER_TYPE_LABELS[type],
  }))
);
